module.exports = __webpack_public_path__ + "static/media/Page.305a381c.png";